import { Employee } from '../employee/employee';
import { EboEvent } from './ebo-event';

export interface IEboEmployeeEvent extends EboEvent {
  employeeID: string;
  employee: Employee;
}
export class EboEmployeeEvent extends EboEvent {
  employeeID: string;
  employee: Employee;

  constructor(jsonData?: Partial<EboEmployeeEvent>) {
    super(jsonData);
    if (this.employee) {
      this.employee = new Employee(jsonData.employee);
    }
  }

  get fedExID(): string {
    return this.employee?.fedExID;
  }
}
